import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'NotFound.title',
    defaultMessage: 'Error 404',
  },
  notFound: {
    id: 'NotFound.notFound',
    defaultMessage: "Sorry, we can't find the page.",
  },
});



// WEBPACK FOOTER //
// ./components/pages/NotFound/messages.js